import { useLayoutEffect, type FunctionComponent } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { useCashierCallbackConnected } from '@pp/core/src/hooks/useCashierCallbackConnected';
import { useSessionBalanceConfig } from '@pp/core/src/store/compositeSelectors/useSessionBalanceConfig';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useIsLargerThanWide } from '@pp/core/src/styles/hooks/media';

import { useCompositeBalance } from '../../../store/compositeSelectors/useCompositeBalance';
import { useGameDispatch } from '../../../store/GameStore';
import { highflyerStateActions } from '../../../store/slices/highflyerState/slice';
import { BalanceWing } from '../balanceWing/BalanceWing';

/**
 *
 * # BalanceWingConnected
 *
 * Component used to display a balance on wider screens. It is a connected components, so it pulls out all the necessary info from store.
 * */
export const BalanceWingConnected: FunctionComponent = () => {
  const balance = useCompositeBalance();
  const cashierCallback = useCashierCallbackConnected();
  const compliance = useConfigSlice.compliance();
  const sessionBalance = useSessionBalanceConfig();
  const sessionBalanceWasSet = compliance?.sessionBalanceWasSet;
  const inDesktopMode = useIsLargerThanWide();
  const dispatch = useGameDispatch();

  const jurisdiction = useConfigSlice.playerConfig()?.jurisdiction;
  const hideBonusBalance = useConfigSlice.getShouldMergeBonusBalance();
  const displayBonusBalance = !hideBonusBalance || jurisdiction === 'X1';

  useLayoutEffect(() => {
    if (balance?.amount === undefined) return;
    dispatch(highflyerStateActions.updateBalance(balance.amount + balance.bonus));
  }, [balance]);

  if (balance?.amount === undefined) return null;

  return (
    <BalanceWing
      balance={
        sessionBalance && !sessionBalanceWasSet && balance.amount > 0 ? (
          '-'
        ) : (
          <CurrencyConnected value={balance.amount} />
        )
      }
      cashierCallback={cashierCallback}
      bonus={displayBonusBalance && inDesktopMode && <CurrencyConnected value={balance.bonus} />}
    />
  );
};
